import React from "react";
import {Button, Row, Col } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import {Helmet} from "react-helmet";
import { withRouter } from 'react-router-dom';

class IndexEvaluate extends React.Component {

    render() {
        const userRole = AuthService.getUserRole()
        const userRoom = this.props.match.params.roomId ? this.props.match.params.roomId : AuthService.getCurrentUser().room.id
        return (
            <div className="">     
                <Helmet>
                    <title>เริ่มต้นค้นหาสิ่งดีๆ รอบตัวคุณ ในช่วงเวลาที่ผ่านมา - Mindsetmaker.co</title>
                    <meta property="og:title"       content={`เริ่มต้นค้นหาสิ่งดีๆ รอบตัวคุณ ในช่วงเวลาที่ผ่านมา - Mindsetmaker.co`} />
                    <meta property="og:description" content={`กิจกรรมค้นหาสิ่งดีๆ ในช่วงเวลาที่ผ่านมา เพื่อค้นพบอุปนิสัยเชิงบวกในตัวเรา เพื่อนๆและคุณครู`} />
                </Helmet>         
                <Row>  
                    <Col xs="12" className="pt-5">
                        <h2 class="font-sarabun-bold primary-text text-center" >เริ่มต้นค้นหาสิ่งดี รอบตัวคุณ</h2>
                    </Col>
                    <Col className="w-100 text-center">
                        <img src='/images/evaluate/index.png' className="mb-1 d-inline pr-2 pt-1" />                        
                    </Col>                    
                </Row>
                <Row>
                    <Col className="pt-4 d-flex">
                        <h4 class="w-600 font-sarabun-bold mx-2 m-md-auto">ในช่วงที่ผ่านมาเราได้มองเห็นอุปนิสัยเชิงบวก
                            อะไรในตัวเอง เพื่อนๆ และคุณครูของเรากัน
                            บ้างนะ? ไปร่วมกันค้นหาอุปนิสัยเชิงบวกของ
                            ทุกคนกันเลยค่ะ
                        </h4>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="px-3 pt-4 pb-3 d-inline w-100 text-center">
                        <Button className="bluesky d-inline py-1 py-1 py-md-2 btn font-sarabun-bold" href={userRole === 'teacher' ? `/evaluate/${userRoom}/overview` : userRole === 'student' ? `/evaluate/overview/${userRoom}` : '/'} >ถัดไป</Button>
                    </Col>
                </Row>
            </div>
        );
    }
};

export default withRouter(IndexEvaluate);